<app-layout-shell [hidden]="appUnavailable" (logout)="logout()">
  <router-outlet></router-outlet>
</app-layout-shell>

<div class="unavailable-wrapper" [hidden]="!appUnavailable || !showDialog">
  <div class="content-wrapper">
    <div class="content">
      <div class="content-brand">
        <img src="/assets/img/Optimize_logo.svg" alt="OPTIMIZE" class="content-brand-logo">
      </div>
      <div class="content-title">{{titleText}}</div>
      <div class="content-subtitle">{{subtitleText}}</div>
      <div *ngIf="showButton" class="content-actions">
        <button type="button" class="action-btn" (click)="buttonClick()">
          <span>{{buttonText}}</span>
        </button>
      </div>
    </div>
  </div>
  <div class="footer-wrapper">
    <div class="footer">
      <div class="footer-brand">
        <img src="/assets/img/TRGScreen-Logo-Text.svg" alt="TRG Screen">
      </div>
      <div class="footer-links">
        <span>Copyright (C) TRGRP, Inc., all rights reserved</span>
        <div class="footer-dot"></div>
        <a href="https://www.trgscreen.com/privacy-policy" target="_blank" rel="noopener">Privacy Statement</a>
      </div>
    </div>
  </div>
</div>

<div *ngIf="maintenance && !appUnavailable" class="maintenance-overlay">
  <span>The application is in maintenance.</span>
</div>
